import React from "react";
import { MsalProvider } from "@azure/msal-react";
import { createMsalInstance  } from "./authConfig";
import App from "./App";
import ReactDOM from 'react-dom/client';
import AppWrapper from "./AppWrapper";
import { loadAppConfig } from "./configService";

async function index() {
  await loadAppConfig();
  const msalInstance = createMsalInstance();

  ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <AppWrapper>
          <App />
        </AppWrapper>
      </MsalProvider>
    </React.StrictMode>
  );
}

index();